import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface HealthCardProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  value?: string | number;
  subtext?: string;
  subtextColor?: string;
  href?: string;
  loading?: boolean;
  children?: React.ReactNode;
}

export const HealthCard: React.FC<HealthCardProps> = ({
  icon: Icon,
  label,
  value,
  subtext,
  subtextColor,
  href,
  loading,
  children,
}) => {
  const content = (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 hover:shadow-md transition-shadow h-full">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-blue-50 text-blue-600 flex-shrink-0">
          <Icon className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">
            {label}
          </p>
          {loading ? (
            <div className="h-6 w-16 bg-gray-200 animate-pulse rounded mt-1" />
          ) : (
            <>
              {value !== undefined && (
                <p className="text-2xl font-bold text-gray-900 mt-0.5">
                  {typeof value === 'number' ? value.toLocaleString() : value}
                </p>
              )}
              {subtext && (
                <p
                  className={cn(
                    'text-xs mt-0.5',
                    subtextColor ?? 'text-gray-500'
                  )}
                >
                  {subtext}
                </p>
              )}
              {children}
            </>
          )}
        </div>
      </div>
    </div>
  );

  if (href) {
    return (
      <Link to={href} className="block">
        {content}
      </Link>
    );
  }
  return content;
};
